import React from 'react';

type Props = {
    children: React.ReactElement;
    value: string;
    index: string;
};

const TabPanel = ({ children, value, index }: Props): React.ReactElement => (
    <div
        style={{ flexGrow: 1, overflowY: 'auto' }}
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
    >
        {value === index && <>{children}</>}
    </div>
);

const MemoTabPanel = React.memo<Props>(TabPanel);
export default MemoTabPanel;
